import React, { useCallback, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Buffer } from "buffer";
import S3 from "react-aws-s3";
import { uid } from "uid";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { useEffect } from "react";
import { config } from "../../Utils";
import Loader from "../../Components/Loader";
import { EditProfileReducer, UserDetailReducer } from "./../slice";
import { toast } from "react-toastify";
window.Buffer = Buffer;

function EditProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [countryData, setCountryData] = useState();
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [time, setTime] = useState(0);

  const QID = uid();
  const ReactS3Client = new S3(config);

  const newFileName = QID;

  useEffect(() => {
    let interval;
    if (isActive && time < 100) {
      interval = setInterval(() => {
        // if (time < 100)
        setTime((seconds) => (seconds < 99 ? seconds + 1 : seconds));
      }, 10);
    }
    return () => clearInterval(interval);
  }, [isActive, time]);

  const detail = useSelector((store) => store.main.userDetail);

  const initialValues = {
    profileImage: detail?.image ? detail?.image : "",
    userName: detail?.userName ? detail?.userName : "",
    registeredProperties: detail?.registeredProperties
      ? detail?.registeredProperties
      : "",
    email: detail?.email ? detail?.email : "",
    countryCode: detail?.countryCode ? detail?.countryCode : "",
    mobile: detail?.phoneNumber ? detail?.phoneNumber : "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      userName: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      mobile: Yup.string().required("Required"),
    }),
    enableReinitialize: true,
    onSubmit: (values, { isSubmitting, resetForm }) => {
      setLoading(true);
      dispatch(
        EditProfileReducer({
          image: values.profileImage,
          userName: values.userName,
          email: values.email,
          // registeredProperties: values.registeredProperties,
          countryCode: values.countryCode,
          phoneNumber: values.mobile,
          // userId: detail?._id,
        })
      ).then((data) => {
        setLoading(false);
        if (data?.payload?.code === 1) {
          toast.success(data.payload.message);
          getDetail();
          navigate("/plan", {
            replace: true,
          });
        } else {
          setLoading(false);
          toast.error(data.payload.message);
        }
      });
    },
  });

  const getDetail = useCallback(() => {
    dispatch(UserDetailReducer({}));
  }, [dispatch]);

  useEffect(() => {
    getDetail();
  }, [getDetail]);

  return (
    <>
      <main className="mx-800">
        <div className="container">
          <form className="form-style mt-5" onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-sm-12 col-md-12 text-center mb-4">
                <h2 className="">Edit Profile</h2>
                <p className="text-center mb-3">
                  Lorem ipsum dolor sit amet, consectetueradipiscing elit.
                  Aenean commodo ligula eget dolor. Aenean massa.
                </p>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 text-center mb-4">
                <div className="upload-btn-wrapper">
                  <button className="btn position-relative">
                    <img
                      src={
                        formik.values?.profileImage?.includes("http")
                          ? formik.values?.profileImage
                          : "assets/images/employe.png"
                      }
                      alt=""
                      className="uploadImge"
                    />

                    <input
                      type="file"
                      accept="image/*"
                      name="profileImage"
                      onChange={(event) => {
                        setIsActive(true);
                        ReactS3Client.uploadFile(
                          event.target.files[0],
                          newFileName
                        )
                          .then((data) => {
                            formik.setFormikState((prevState) => {
                              return {
                                ...prevState,
                                values: {
                                  ...prevState.values,
                                  profileImage: data.location,
                                },
                              };
                            });
                            setTime(100);
                            setIsActive(true);
                            setTimeout(() => {
                              setTime(0);
                              setIsActive(false);
                            }, 3000);
                            //console.log(data.location);
                          })
                          .catch((err) => console.error(err));
                      }}
                    />
                  </button>
                </div>
                {time > 0 && isActive && (
                  <Progress type="line" width={100} percent={time} />
                )}
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 mb-4">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      value={formik.values.userName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="userName"
                    />
                    <img
                      src="assets/images/user.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.userName && formik.touched.userName && (
                    <div className="text-red"> {formik.errors.userName}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-4">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="email"
                    />
                    <img
                      src="assets/images/email.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.email && formik.touched.email && (
                    <div className="text-red"> {formik.errors.email}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-4">
                <div className="form-group">
                  <div className="input-container">
                    <PhoneInput
                      country="in"
                      inputProps={{
                        name: "mobile",
                      }}
                      enableSearch
                      value={
                        formik.values.mobile
                          ? formik.values.countryCode + formik.values.mobile
                          : undefined
                      }
                      onChange={(phone, country, e, formattedValue) => {
                        setCountryData({ formattedValue, country });
                        if (phone.length > 0) {
                          const raw = phone.slice(country?.dialCode?.length);
                          formik.setFieldValue("mobile", raw);

                          formik.setFieldValue(
                            "countryCode",
                            formattedValue?.split(" ")[0]
                          );
                        } else {
                          formik.setFieldValue("mobile", "");

                          formik.setFieldValue("countryCode", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Phone Number"
                      containerclassName="form-control signupClass"
                      inputclassName="phoneInputClass"
                    />
                    <img
                      src="assets/images/phone.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.mobile && formik.touched.mobile && (
                    <div className="text-red"> {formik.errors.mobile}</div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 mb-4 d-none">
                <div className="form-group">
                  <div className="input-container">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Registered Properties"
                      value={formik.values.registeredProperties}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="registeredProperties"
                    />
                    <img
                      src="assets/images/Property.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {formik.errors.registeredProperties &&
                    formik.touched.registeredProperties && (
                      <div className="text-red">
                        {" "}
                        {formik.errors.registeredProperties}
                      </div>
                    )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 text-center">
                <button className="btn btn-save w-50">
                  {loading ? <Loader /> : "Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </>
  );
}

export default EditProfile;
